import { create } from 'zustand';
import { persist } from 'zustand/middleware';

interface DashboardState {
  hiddenItems: string[];
  isEditMode: boolean;
  toggleEditMode: () => void;
  hideItem: (id: string) => void;
  showItem: (id: string) => void;
  toggleItemVisibility: (id: string) => void;
  isItemHidden: (id: string) => boolean;
  resetHiddenItems: () => void;
}

export const useDashboardStore = create<DashboardState>()(
  persist(
    (set, get) => ({
      hiddenItems: [],
      isEditMode: false,
      toggleEditMode: () => set(state => ({ isEditMode: !state.isEditMode })),
      hideItem: (id) => set(state => ({
        hiddenItems: [...state.hiddenItems, id]
      })),
      showItem: (id) => set(state => ({
        hiddenItems: state.hiddenItems.filter(itemId => itemId !== id)
      })),
      toggleItemVisibility: (id) => {
        const isHidden = get().isItemHidden(id);
        if (isHidden) {
          get().showItem(id);
        } else {
          get().hideItem(id);
        }
      },
      isItemHidden: (id) => get().hiddenItems.includes(id),
      resetHiddenItems: () => set({ hiddenItems: [] })
    }),
    {
      name: 'dashboard-preferences',
      version: 1
    }
  )
);